import { render, staticRenderFns } from "./WidgetPanel.vue?vue&type=template&id=05e63d39&scoped=true&lang=pug"
import script from "./WidgetPanel.vue?vue&type=script&lang=js"
export * from "./WidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./WidgetPanel.vue?vue&type=style&index=0&id=05e63d39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e63d39",
  null
  
)

export default component.exports